import type { ChamberSettingsFormState } from "./settingsData";

// Design (11) Chamber Global Settings (CMP Dashboard 6075-6139, 6224):
// Fiscal Year, Currency and Time Zone are required before the section saves.
export const CHAMBER_GLOBALS_REQUIRED_MESSAGE =
  "Please complete the required fields: Fiscal Year, Currency and Time Zone.";

export type ChamberGlobalsRequiredField = "fiscalYear" | "currency" | "timeZone";

export const getMissingChamberGlobalsFields = (
  setup: Pick<
    ChamberSettingsFormState["setup"],
    "fiscalYearStartMonth" | "fiscalYearStartDay" | "currency" | "timeZone"
  >,
): ChamberGlobalsRequiredField[] => [
  ...(!setup.fiscalYearStartMonth.trim() || !setup.fiscalYearStartDay.trim()
    ? (["fiscalYear"] as const)
    : []),
  ...(!setup.currency.trim() ? (["currency"] as const) : []),
  ...(!setup.timeZone.trim() ? (["timeZone"] as const) : []),
];

// Thunderbay Chamber Set Up (TB11 6228-6230): both Multi-Billing Dates are
// required while the switch is on.
export const MULTIPLE_BILLING_DATES_REQUIRED_MESSAGE =
  "Please select both billing dates.";

export const areMultipleBillingDatesMissing = (
  setup: Pick<ChamberSettingsFormState["setup"], "multipleBillingDates" | "multipleBillingDatesAvailable">,
) =>
  !!setup.multipleBillingDatesAvailable &&
  !!setup.multipleBillingDates?.enabled &&
  (!setup.multipleBillingDates.firstBillingDate.month ||
    !setup.multipleBillingDates.firstBillingDate.day ||
    !setup.multipleBillingDates.secondBillingDate.month ||
    !setup.multipleBillingDates.secondBillingDate.day);

// Claude Design (13) CMP Dashboard 6188, 16036: the Fix Date is required
// while its switch is on.
export const RENEWAL_FIXED_DATE_REQUIRED_MESSAGE =
  "Please select a Membership Renewal Fix Date.";

export const isRenewalFixedDateMissing = (
  setup: Pick<
    ChamberSettingsFormState["setup"],
    "membershipRenewalFixedDateEnabled" | "membershipRenewalFixedDateMonth" | "membershipRenewalFixedDateDay"
  >,
) =>
  setup.membershipRenewalFixedDateEnabled &&
  (!setup.membershipRenewalFixedDateMonth || !setup.membershipRenewalFixedDateDay);
